import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { RefdataProvider } from "../../providers/refdata/refdata";
import { SvgProvider } from '../../providers/svg/svg';
//import { app } from 'firebase';

import { jQuery } from 'jquery/dist/jquery';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

enum ButtonTypes {
  DETAILS_BUTTON,
  DETAILS_CHILD,
  NONE,
  PARENT,
  ONE_TO_FIVE_PARENT,
  ONE_TO_FIVE_CHILD,
  COLOR_PARENT,
  /*COLOR_CHILD,
  COLOR_CHILD_IMAGE,*/
  CELL_COLOR,
  CELL_CLARITY_NO_IMAGE,
  CELL_CLARITY_IMAGE
}

@Component({
  selector: 'beer-aromas',
  templateUrl: 'beer-aromas.html',
  styleUrls: ['./beer-aromas.scss'],
  standalone: false
})
export class BeerAromasComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('aromaCanvas') aromaCanvas: ElementRef;

  private _CANVAS: any;
  private _CONTEXT: any;

  _aromaValues: Array<any> = new Array<any>();

  buttons: Array<any>;

  startX: number;
  startY: number;
  xOffset: number;
  yOffsetFull: number;
  yOffsetHalf: number;

  aromaWidth: number = window.innerWidth;
  aromaHeight: number = window.innerWidth;

  middleX: number = 0;
  middleY: number = 0;

  //margins from borders
  left: number = 5;
  right: number = 5;
  top: number = 5;
  bottom: number = 5;

  // a cell is 2 * radius wide
  radius: number = 0;

  cellHeight: number = 0;

  //number of radius that the view is "wide"
  widthCount: number = 7;//was 5

  w: number = 0;
  h: number = 0;

  selectedColor: number = -1;//no selection
  selectedClarity: number = -1;//no selection

  private icon_aroma_svg_path: string;

  // private updateAromasSubscription: any;

  constructor(
    private svgProvider: SvgProvider,
    private refdata: RefdataProvider,
    private events: AppEventService,
    private translateService: TranslateService
  ) {
    this.buttons = [
      {
        identifier: "color1",
        buttons: [
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#FFFFCD"],
            selected: false,
            label: "",
            key: "col1"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#FFC000"],
            selected: false,
            label: "",
            key: "col3"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#CC6601"],
            selected: false,
            label: "",
            key: "col5"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#A94124"],
            selected: false,
            label: "",
            key: "col7"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#080808"],
            selected: false,
            label: "",
            key: "col9"
          },
          {
            svgPath: "",
            type: ButtonTypes.CELL_COLOR,
            colors: ["#080808"],
            selected: false,
            label: "",
            key: "col9"
          }
        ],
        selected: false,
        type: ButtonTypes.NONE
      }
    ];

    this._aromaValues = [];
    this.subscribeToAromaUpdates();

    this.icon_aroma_svg_path = 'assets/svg/icon_aroma.svg';
  }

  initCanvas() {
    if (this._CANVAS.getContext) {
      this.setupCanvas();
    }
  }

  setupCanvas() {
    this._CONTEXT = this._CANVAS.getContext('2d');
    this._CONTEXT.fillStyle = "#ff0000";
    this._CONTEXT.fillRect(0, 0, this.w, this.h);
  }

  clearCanvas() {
    this._CONTEXT.clearRect(0, 0, this._CANVAS.width, this._CANVAS.height);
    this.setupCanvas();
  }

  updateAromasSubscription = (aromas: any) => {
      console.log("[beer-aromas] SUB update:aromas");

      //aromas is an array (that could be empty)
      //it just contains a number of strings
      //e.g. hoppy_old, wood_oak, malty_burnt, spices_coriander
      this._aromaValues = [];

      let count = 0;

      for (let aromaIndex in aromas) {
        let aroma = aromas[aromaIndex];
        let underscoreIndex = aroma.indexOf("_");
        if (underscoreIndex != -1) {
          if (count++ < 8) {
            this._aromaValues.push({
              "value": aroma
            });
          }
        }
        else {
          console.log("[beer-aromas] not adding aroma value " + aroma);
        }
      }

      this.clearAromas();
      if (this._aromaValues.length >= 0) {
        this.drawCellsSvg(this._aromaValues, this.startX, this.startY);
      }
      else {
        // empty canvas
        this.clearAromas();
      }
  }
/*
  @Input() set aromaValues(value: any) {
    if (value) {
      console.log("[beer-aromas] - set aromaValues: value = " + value);
      this.updateAromasSubscription(value);
    }
    else {
      console.log("[beer-aromas] - set aromaValues: called without value");
    }
  }
*/
  ngOnInit(): void {
    console.log("[beer-aromas] ngOnInit");
    this.events.subscribe("beer-detail:update:beer-aromas", this.updateAromasSubscription);
    }
  subscribeToAromaUpdates() {
    console.log("[beer-aromas]subscribeToAromaUpdates");
    this.events.subscribe("update:aromas", this.updateAromasSubscription);
  }

  clearAromas() {
    let mySvgRoot: jQuery<HTMLElement> = $('#aromaSvgContainer');
    mySvgRoot.empty();

    mySvgRoot.css('display', 'block');
  }

  ngOnDestroy() {
    console.log("[beer-aromas] ngOnDestroy");
    this.events.unsubscribe("update:aromas", this.updateAromasSubscription);
    this.events.unsubscribe("beer-detail:update:beer-aromas", this.updateAromasSubscription);
  }

  ngAfterViewInit() {
    console.log("[beer-aromas]ngAfterViewInit");

    this._CANVAS = this.aromaCanvas.nativeElement;

    this.w = window.innerWidth;
    this._CANVAS.width = this.w;

    this.left = 5;
    this.right = 5;
    this.top = 5;
    this.bottom = 5;

    this.h = this.w / 4.5;

    this._CANVAS.height = this.h;

    this.cellHeight = 2 * (this.h - this.top - this.bottom) / 3;

    //console.log("AROMA - size of CANVAS: " + this.w + " x " + this.h);

    this.radius = this.cellHeight / Math.sqrt(3.0);

    // kijken of het hierdoor niet te breed wordt
    let totalWidth = 14 * this.radius;
    //console.log("AROMA - width with this radius: " + totalWidth);
    // zo ja, aanpassen zodat het wel past
    if (totalWidth > this.w) {
      //console.log("AROMA - TOO WIDE");
      // work the other way around, determine radius based on this.w
      this.radius = (this.w - this.left - this.right) / 14;
      //this.left = 0;
      //this.right = 0;
      // remaining width will be 0; so no need to change this.left
      this.startX = this.radius;
      this.startY = this.top + this.radius / 4;
      this.xOffset = 0; //this.radius; //this.size * 1.5;
      this.yOffsetFull = this.radius * 1.75;
      this.yOffsetHalf = this.radius * 1.75 / 2;

      this.cellHeight = this.radius * Math.sqrt(3.0);

      let heightRemaining = this.h - (3 / 2 * this.cellHeight);
      //console.log("AROMA - height remaining: " + heightRemaining);
      this.startY += heightRemaining / 2;
      // = or +=?
      this.top = heightRemaining / 2;

      //this.radius = this.cellHeight / Math.sqrt(3.0);
    }
    else {
      //console.log("AROMA - width is OK");
      this.startX = this.radius;
      this.startY = this.top/* + this.radius*/;
      this.xOffset = 0; //this.radius; //this.size * 1.5;
      this.yOffsetFull = this.radius * 1.75;
      this.yOffsetHalf = this.radius * 1.75 / 2;
    }
    this.drawCellsSvg(this._aromaValues, this.startX, this.startY);
  }

  //TODO: provide a translation table
  private RealValue(value: String) {

    //check for aromas that share the same image!
    if (value === "fruity_blackberry")
      value = "fruity_raspberry";
    if (value === "fruity_wildcherry")
      value = "fruity_cherry";
    if (value === "fruity_wild_cherry")
      value = "fruity_cherry";
    if (value === "fruity_green_apple")
      value = "fruity_apple";
    if (value === "fruity_red_apple")
      value = "fruity_apple";
    if (value === "fruity_greenapple")
      value = "fruity_apple";
    if (value === "fruity_redapple")
      value = "fruity_apple";
    if (value === "misc_medicinal")
      value = "misc_medicinal";

    //console.log("realvalue: **" + value + "**");
    return this.refdata.svgBaseUrl + "icon_aroma_" + value + ".svg";
  }

  private RealLabel(value: String) {

    var realValue = value.substring(value.indexOf("_") + 1);
    var label = this.translateService.instant('BUTTONS.' + realValue.toUpperCase());
    if (label === realValue.toUpperCase()) {
      console.log("RealLabel - warning: label " + realValue.toUpperCase() + " not found!")
      return '?' + realValue + '?'; //TODO
    } else {
      return label;
    }
  }

  private drawCellsSvg(aromaValues: Array<any>, x: number, y: number) {
    var centerX = this.radius + this.left;
    var centerY = this.radius + this.top;
    var iconScale = 0.75;
    var iconSize = this.radius * 2 * iconScale;
    var iconTranslationX = this.left + this.radius * (1 - iconScale);
    var iconTranslationY = this.top + this.radius * (1 - iconScale);
    var mySvg = this.svgElementStart();
    var titleHexagon = this.svgProvider.drawHexagon('myFirstHexagon', this.radius + this.left, this.radius + this.top, this.radius, this.refdata.titleHexagonStyle);
    var titleIcon = '<g transform="translate(' + iconTranslationX + ',' + iconTranslationY + ')">' +
      '<image xlink:href="' + this.icon_aroma_svg_path + '" ' + ' " height="' + iconSize + '" width="' + iconSize + '"' + '/>' +
      '</g>';

    mySvg += titleHexagon;
    mySvg += titleIcon;

    //now, draw cell 1..6 (something between 1 and 6, depending on aromaValues)
    // icons for binary aromas are somewhat smaller
    iconScale = 0.55;
    iconSize = this.radius * 2 * iconScale;
    //let iconLeftOffset = iconScale/2.0;

    var eventHandlers: Array<any> = new Array<any>();

    let cell = 0;
    for (cell = 0; cell < this._aromaValues.length; cell++) {

      let value = this._aromaValues[cell].value;
      let realValue = this.RealValue(value);

      centerX += Math.round(3 * this.radius / 2);
      if (cell % 2 == 0)
        centerY += Math.round(this.cellHeight / 2);
      else
        centerY -= Math.round(this.cellHeight / 2);

      let b: any;
      b = {};

      b.x = centerX;
      b.y = centerY;
      b.svgPath = realValue;
      b.label = this.RealLabel(value);

      iconTranslationX = centerX - this.radius * iconScale; // centerX + this.left - this.radius + (this.radius * 0.2);
      iconTranslationY = centerY - (this.radius * 0.8); // + this.top - this.radius*1.55 - (this.radius * 0.05);
      var textTranslationX = centerX;
      var textTranslationY = centerY + this.radius / 1.85;
      var myAromaSvg = this.svgProvider.drawHexagon('aromaHexagon_' + cell, b.x, b.y, this.radius, this.refdata.aromaHexagonStyle);
      var myAromaIcon = this.svgProvider.drawIcon(iconTranslationX, iconTranslationY, b.svgPath, iconSize, iconSize);

      var myAromaText = this.svgProvider.drawAromaText(b.label, textTranslationX, textTranslationY);
      var clickId = 'clickAromaHexagon_' + cell;
      var myAromaClickSvg = this.svgProvider.drawHexagon(clickId, b.x, b.y, this.radius, 'opacity:0;');
      eventHandlers.push({ id: clickId, event: 'click', data: { aroma: value }, handler: this.aromaClickHandler });
      '</g>';

      mySvg += myAromaSvg;
      mySvg += myAromaIcon;
      mySvg += myAromaText;
      mySvg += myAromaClickSvg;

    }

    mySvg += '</svg>';

    //    this._svgDiv.innerHTML = mySvg;
    let mySvgRoot: jQuery<HTMLElement> = $('#aromaSvgContainer');
    mySvgRoot.empty();
    mySvgRoot.append(mySvg);

    eventHandlers.forEach(element => {
      $('#' + element.id).on(element.event, element.data, element.handler);
    });
    mySvgRoot.css('display', 'block');

  }

  public aromaClickHandler(event) {
    console.log('aromaClickHandler clicked for aroma ' + event.data.aroma);
  }
  private svgElementStart() {
    return '<svg xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/"' +
      ' xmlns:dc="http://purl.org/dc/elements/1.1/"' +
      ' xmlns:cc="http://creativecommons.org/ns#"' +
      ' xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"' +
      ' xmlns:svg="http://www.w3.org/2000/svg"' +
      ' xmlns="http://www.w3.org/2000/svg"' +
      ' xmlns:xlink="http://www.w3.org/1999/xlink"' +
      ' xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"' +
      ' id="binary-aromas-svg-svg" version="1.1" ' + this.svgViewAttributes(0, 0, this.w, this.h) + '>';
  }
  private svgViewAttributes(x, y, width, height) {
    return 'viewBox="' + x + ' ' + y + ' ' + width + ' ' + height + '"' +
      ' " height="' + height + '" width="' + width + '"';
  }
}
